export default "__VITE_ASSET__FHfnPre___"